import { useEffect, useRef, useState } from "react";

/** Toolbar "Plans" dropdown: Plans / Import KMZ / Export KMZ (plan list). */
function PlansMenu({ plans, loading, onRefresh, onOpenDrawer, onImportFile, onExport, disabled }) {
  const [open, setOpen] = useState(false);
  const [view, setView] = useState(null); // null | "export"
  const wrapRef = useRef(null);
  const fileRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const toggle = () => {
    if (disabled) return;
    setOpen((o) => {
      const next = !o;
      if (next) {
        setView(null);
        onRefresh();
      }
      return next;
    });
  };

  const handleFile = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;
    setOpen(false);
    await onImportFile(file);
  };

  return (
    <div className="cs-menu-wrap" ref={wrapRef}>
      <button
        className="cs-btn"
        onClick={toggle}
        disabled={disabled}
        title={disabled ? "Select a project first" : "Plans / import / export"}
      >
        ☰ Plans ▾
      </button>
      {open && (
        <div className="cs-menu" role="menu">
          <button
            className="cs-menu-item"
            onClick={() => {
              setOpen(false);
              onOpenDrawer();
            }}
          >
            Plans
          </button>
          {onImportFile && (
            <button className="cs-menu-item" onClick={() => fileRef.current?.click()}>
              ⇧ Import KMZ
            </button>
          )}
          <button
            className="cs-menu-item"
            onClick={() => setView((v) => (v === "export" ? null : "export"))}
          >
            Export KMZ {view === "export" ? "▲" : "▸"}
          </button>
          {view === "export" && (
            <div className="cs-menu-sub">
              {loading && <span className="cs-hint">Loading…</span>}
              {!loading && plans.length === 0 && <span className="cs-hint">No saved plans.</span>}
              {plans.map((p) => (
                <button
                  key={p.id}
                  className="cs-menu-item"
                  onClick={() => {
                    setOpen(false);
                    onExport(p);
                  }}
                >
                  ⬇ {p.name}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
      <input
        ref={fileRef}
        type="file"
        accept=".kmz,.kml"
        className="cs-hidden-input"
        onChange={handleFile}
      />
    </div>
  );
}

export default PlansMenu;